export const LEGACY_BASE_PATH = '/PlanierUI/index.html#'
